export const buttonStyle: React.CSSProperties = {
  fontSize: "12px",
  width: "85px",
  height: "20px",
  padding: "0",
  minWidth: "80px",
  minHeight: "20px",
};
